/** Trim and validate featured image URL for interlink hover cards. */
export function normalizeLinkPreviewFeaturedImageUrl(
	featuredImageUrl: string | null | undefined
): string | null {
	const url = featuredImageUrl?.trim();
	return url && url.length > 0 ? url : null;
}
